import { render, staticRenderFns } from "./ProcessoUtilizacaoView.vue?vue&type=template&id=028963ee"
import script from "./ProcessoUtilizacaoView.vue?vue&type=script&lang=js"
export * from "./ProcessoUtilizacaoView.vue?vue&type=script&lang=js"
import style0 from "./ProcessoUtilizacaoView.vue?vue&type=style&index=0&id=028963ee&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports